export default __webpack_public_path__ + "static/media/hero-spesial.d74b76b1.png";